import { observer } from "mobx-react-lite";
import { Form as FinalForm, Field } from "react-final-form";
import React, { useContext } from "react";

// reactstrap components
import {
  Alert,
  Button,
  FormGroup,
  Form,
  Row,
  Col,
} from "reactstrap";
import { IUserConfirmResetPwdValues } from "../../app/models/user";
import { FORM_ERROR } from "final-form";
import { RootStoreContext } from "../../app/stores/rootStore";
import TextInput from "../common/TextInput";
import { combineValidators, isRequired } from "revalidate";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";
import LogoCompany from "../common/LogoCompany";

const validate = combineValidators({
  password: isRequired("password"),
  token: isRequired("token"),
  id: isRequired("id"),
});

interface PwdChangeParams {
  userId: string;
  token: string;
  onSuccess: () => void;
}

export const ChangePwdForm: React.FC<PwdChangeParams> = ({
  userId,
  token,
  onSuccess,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { confirmResetPwd } = rootStore.userStore;
  const [t] = useTranslation(
    ["features", "translation", "errors"],
    translationHookOptions
  );

  return (
    <>
      <div className="form-wrapper  mt-0">
        <div>
          <LogoCompany className="loginLogo" />
        </div>
        <h5>
          <b>{t("reset_pwd_form_insert_new")}</b>
        </h5>
        <FinalForm
          initialValues={{
            password: "",
            token: `${token}`,
            id: `${userId}`,
          }}
          onSubmit={(values: IUserConfirmResetPwdValues) =>
            confirmResetPwd(values)
              .then(() => onSuccess())
              .catch((error) => ({
                [FORM_ERROR]: error,
              }))
          }
          validate={validate}
          render={({
            handleSubmit,
            submitError,
            invalid,
            pristine,
            dirtySinceLastSubmit,
          }) => (
            <Form onSubmit={handleSubmit} role="form">
              <FormGroup className="form-group input-group-lg mb-3">
                <Field
                  name="password"
                  component={TextInput}
                  placeholder="password"
                  type="password"
                  autoComplete="off"
                />
                <Field name="token" component={TextInput} type="hidden" />
                <Field name="id" component={TextInput} type="hidden" />
              </FormGroup>
              {submitError && !dirtySinceLastSubmit && (
                <Alert color="danger" className="w-100">
                {submitError.data  && submitError.data.errors ? (
                 
                 <ul style={{ textAlign: "left" ,paddingLeft:"3%"}}>
                    {submitError.data.errors
                      .map((error: any) => error.errorCode)
                      .map((errorCode: any, index: any) => (
                        <li key={index} style={{marginTop:"3%"}}>
                          {" "}
                          {t(errorCode, { ns: "errors" })}.
                        </li>
                      ))}
                  </ul>
                  
                ) : null}
               </Alert>
              )}
              <div className="text-center">
                <Button
                  disabled={(invalid && !dirtySinceLastSubmit) || pristine}
                  className="btn loginButton btn-block btn-lg"
                  color="dark"
                  type="submit"
                >
                  {t("confirm", { ns: "translation" })}
                </Button>
              </div>
            </Form>
          )}
        />

        <Row className="mt-3 text-center">
          <Col>
          <div className="text-center text-muted mt-4 mb-2">
              <h6 className="linedText">
                <span className="linedSpan">{t("login_method_separator" , { ns: "translation" })}</span>
              </h6>
            </div>
            <a
              className="btn btn-dark loginButton text-white btn-outline-light btn-sm"
              href="/"
            >
              {t("reset_pwd_form_home_link")}
            </a>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default observer(ChangePwdForm);
